/* istanbul ignore file */
import React from 'react';

function IconInstagram() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    className: "icon-instagram",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      width: 42
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    fill: "#01ACED",
    d: "M16,0c8.8,0,16,7.2,16,16s-7.2,16-16,16S0,24.8,0,16S7.2,0,16,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-2",
    fill: "#ffffff",
    d: "M21.5,7h-11C8.6,7,7,8.6,7,10.5v11c0,1.9,1.6,3.5,3.5,3.5h11c1.9,0,3.5-1.6,3.5-3.5v-11C25,8.6,23.4,7,21.5,7z\nM22.6,9L23,9v3l-3,0l0-3C20,9,22.6,9,22.6,9z M16,13c2.5,0,3,2.3,3,3c0,1.7-1.4,3-3,3c-1.7,0-3-1.4-3-3C13,15.3,13.5,13,16,13z\nM23,21.3c0,1-0.8,1.7-1.7,1.7H10.7c-1,0-1.7-0.8-1.7-1.7V14h2.5c-0.2,0.6-0.4,1.4-0.4,2c0,2.7,2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9\nc0-0.7-0.1-1.4-0.4-2H23L23,21.3L23,21.3z"
  }));
}

export default IconInstagram;